import { FormGroup } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const FormGroupWithMoreBottomMargin = styled(FormGroup)`
  margin-bottom: 2rem;
`;
